import React from "react";
import { CalendarClock, Music, Disc3, PartyPopper, Sparkles, Radio } from "lucide-react";
import { PROGRAMS } from "../mock";

const ICONS = { Music, Disc3, PartyPopper, Sparkles, Radio };

const Programmas = () => {
  return (
    <div className="min-h-screen">
      <section className="relative overflow-hidden pt-40 pb-24">
        <div className="absolute -top-40 left-1/2 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-white/25 blur-3xl" />
        <div className="relative mx-auto max-w-3xl px-5 sm:px-8 text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full glass-tint px-4 py-1.5 text-sm font-semibold text-white">
            <CalendarClock className="h-4 w-4" /> Programmering
          </span>
          <h1 className="mt-6 font-heading text-5xl font-extrabold text-white sm:text-6xl">Programma's</h1>
          <p className="mx-auto mt-6 max-w-xl text-lg text-white/90">
            Ontdek wanneer je jouw favoriete All-In Radio programma's kunt beluisteren.
          </p>
        </div>
      </section>

      <section className="pb-28">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <div className="space-y-5">
            {PROGRAMS.map((p) => {
              const Icon = ICONS[p.icon] || Radio;
              return (
                <div
                  key={p.id}
                  data-testid={`program-${p.id}`}
                  className="group flex items-start gap-4 rounded-2xl bg-[#4288F5] border border-white/15 p-5 sm:p-6 shadow-[0_18px_40px_-22px_rgba(8,30,80,0.5)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#4f92f7]"
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white ring-1 ring-white/25 transition-colors group-hover:bg-white group-hover:text-[#1E6BE6]">
                    <Icon className="h-6 w-6" />
                  </span>
                  <div className="min-w-0 flex-1">
                    <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-white/70">
                      <CalendarClock className="h-3.5 w-3.5" /> {p.schedule}
                    </span>
                    <h2 className="mt-1.5 font-heading text-xl font-extrabold text-white">{p.name}</h2>
                    <p className="mt-1 text-sm leading-relaxed text-white/85">{p.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Programmas;
